<template>
  <div class="sp-template">
    <div class="h-title">系统信息</div>
    <el-card class="box-card">
      <!-- 全部公告内容 -->
      <div class="bulletin-content">
        <ul class="list-group">
          <li class="list-group-item" v-for="item in unreadSystemInfoList" :key="item.id">
            <a class="not-read" href="#" @click.prevent="showDetailedBulletion(item)">
              <el-row>
                <el-col :span="2">
                  <div class="year-month">{{item.createDate.substring(0,4)}}</div>
                  <div class="day">{{item.createDate.substring(5,10)}}</div>
                  <div class="year-month">{{item.createDate.substring(10)}}</div>
                </el-col>
                <el-col :span="22">
                  <h4 class="title">
                    <!-- <i v-if="true" class="iconfont icon-New"></i> -->
                    <i class="new-gif__icon"></i>
                    {{item.title}}
                  </h4>
                  <div class="content ql-editor" v-html="item.content"></div>
                </el-col>
              </el-row>
            </a>
          </li>
          <li class="list-group-item" v-for="item in systemInfoList" :key="item.id">
            <a :class="[item.isRead ? 'has-read' : 'not-read']" href="#" @click.prevent="showDetailedBulletion(item)">
              <el-row>
                <el-col :span="2">
                  <div class="year-month">{{item.createDate.substring(0,4)}}</div>
                  <div class="day">{{item.createDate.substring(5,10)}}</div>
                  <div class="year-month">{{item.createDate.substring(10)}}</div>
                </el-col>
                <el-col :span="22">
                  <h4 class="title">
                    <!-- <i v-if="true" class="iconfont icon-New"></i> -->
                    <i v-if="!item.isRead" class="new-gif__icon"></i>
                    {{item.title}}
                  </h4>
                  <div class="content text-content ql-editor" v-html="item.content"></div>
                </el-col>
              </el-row>
            </a>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
      <!-- 系统公告-弹层 -->
      <el-dialog title="系统公告" :visible.sync="dialogBulletinVisible" append-to-body width="30%">
        <div class="dialog-content">
          <span class="title">标题：</span>
          <span class="content">{{checkNotices.title}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">优先级：</span>
          <span class="content">{{checkNotices.level == 1 ? "紧急" : "一般"}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">发布公司：</span>
          <span class="content">{{checkNotices.orgOp}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">发布时间：</span>
          <span class="content">{{checkNotices.createDate}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">内容：</span>
          <span class="content text-content ql-editor" v-html="checkNotices.content"></span>
        </div>
      </el-dialog>
    </el-card>
    <div class="submit-buttons">
      <el-button @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      systemInfoList: [],
      unreadSystemInfoList: [],
      checkNotices: "",
      dialogBulletinVisible: false,
      currentPage: 1, // 当前是第几页
      pageSize: 20, // 每页显示条目个数
      total: 0 // 总条目数
    };
  },
  created() {
    setTimeout(() => {
      this.queryNotice(
        this.currentPage,
        this.pageSize,
        this.$route.query.status
      );
    }, 600);
  },
  methods: {
    showDetailedBulletion(data) {
      this.checkNotices = data;
      this.createdReadNotice(data.id, data.isRead);
      this.dialogBulletinVisible = true;
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.queryNotice(currentPage, this.pageSize, this.$route.query.status);
    },
    handleSizeChange(pageSizes) {
      this.pageSize = pageSizes;
      this.queryNotice(
        this.currentPage,
        this.pageSize,
        this.$route.query.status
      );
    },
    queryNotice(currentPage, pageSize, status) {
      this.$request1({
        method: 'GET',
        url: '/notice/systeminfo',
        params: {
          currentPage: currentPage,
          pageSize: pageSize,
          status: status
        }
      })
        .then(response => {
          if (response.data.success) {
            this.total = response.data.total;
            this.unreadSystemInfoList = response.data.data.unread;
            this.systemInfoList = response.data.data.all;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    createdReadNotice(noticeId, isRead) {
      if (isRead) {
        return;
      }
      this.$request1({
        method: 'POST',
        url: '/readNotice/create',
        params: {
          noticeId: noticeId
        }
      })
        .then(response => {
          console.log(response.data);
          this.queryNotice(
            this.currentPage,
            this.pageSize,
            this.$route.query.status
          );
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.bulletin-content {
  .list-group-item a {
    display: block;
    width: 100%;
    padding: 15px 25px 15px 5px;
    color: #989898;
    border-bottom: 1px solid #e6e6e6;
    .day {
      font-size: 26px;
    }
    .title {
      margin-bottom: 10px;
    }
    .content {
      width: 100%;
      & :first-child {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      & :not(:first-child) {
        display: none;
      }
    }
    &.not-read {
      .day,
      .year-month,
      .title {
        color: rgb(34, 34, 34);
      }
      .year-month,
      .title {
        font-weight: 700;
      }
    }
    &.has-read {
      .day,
      .year-month,
      .title {
        color: #989898;
      }
    }
  }
}
// .year-month{
//   padding-left: 15px;
// }
.el-pagination {
  margin-top: 50px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/views/usercenter/systeminfo.vue